export const SETTLEMENT_REPORT_TYPE_VALUES = [
    {value: 'Daily', label: 'Daily reports'},
    {value: 'Batch', label: 'Batch reports'},
];
